export const FavouriteStates = {
    Pending: "pending",
    Error: "error",
    Favourite: "favourite",
    Unfavourite: "unfavourite"
};
